import * as angular from "angular";
import {IController, ILocationService, IScope} from "angular";
import * as _ from "lodash";
import {CoordinationsAlerts} from "../../services/coordinations-alerts.service";
import {CoordinationsDialogService} from "../../services/coordinations-dialog-service.service";
import {CoordinationRequests} from "../../services/coordinations-requests.service";
import {DeliveriesAlertsService} from "../../../deliveries/services/deliveries-alerts.service";

export class coordinationDetailViewCtrl implements IController {

  coordination: any;
  services: any;

  private serviceStatuses: any;
  private queryString: string;
  private selectedServiceIds: any;
  private selectAllServicesMode: boolean;
  private loading: boolean;

  /* @ngInject */
  constructor(private coordinationsDialogService: CoordinationsDialogService, private coordinationRequests: CoordinationRequests, private $log,
              private deliveriesAlertsService: DeliveriesAlertsService, private CoordinationConstants, private coordinationsAlerts: CoordinationsAlerts,
              private $scope: IScope, private $coordinations, private $location: ILocationService, private $anchorScroll) {
  }

  $onInit() {
    this.serviceStatuses = this.CoordinationConstants.IEnumServiceStatus;
    this.queryString = '';
    this.selectedServiceIds = {};
    this.selectAllServicesMode = false;

    // Barcode Event
    this.$scope.$on('barcode-scanned', (event, barcode) => {
      this.$log.info('Scan detected, bar code is : ', barcode);
      const service = _.find(this.services, (service) => {
        return _.isEqual(service.barCode, barcode)
      });

      if (service) {
        this.selectedServiceIds[service.id] = true;
        this.$location.hash(barcode);
        this.$anchorScroll();
        this.deliveriesAlertsService.barcodeScanSuccess(barcode);
      } else {
        this.deliveriesAlertsService.barcodeScanError(barcode);
      }
    });

  };

  $onChanges(changes) {
    if (changes.services && !changes.services.isFirstChange()) {
      this.selectedServiceIds = {};
    }
  };

  /////////////////////////////////////////////////////

  // ******************************
  //        External methods
  // ******************************

  editCoordination(event) {
    this.coordinationsDialogService.editCoordination(event, this.coordination)
      .then((updatedCoordination) => {
        this.loading = true;
        this.coordination = updatedCoordination;
        this.getServices();
      })
      .finally(() => {
        this.$log.info('Closed Dialog')
      })
  }

  onQueryChange(query) {
    this.queryString = query;
  }

  createDeliveries(event) {
    const selectedServicesIdList = this.getSelectedServiceIdList();
    this.coordinationsDialogService.createDeliveries(event, this.coordination, selectedServicesIdList)
      .then((updatedServices) => {
        if (updatedServices) {

          if (selectedServicesIdList.length > 1) {
            this.coordinationsAlerts.createServicesSuccess();
          } else {
            this.coordinationsAlerts.createServiceSuccess();
          }

          this.updateService(updatedServices);
          this.getCoordination();
        }
      })
      .catch((error) => {
          if (error) {
            if (selectedServicesIdList.length > 1) {
              this.coordinationsAlerts.createServicesError();
            } else {
              this.coordinationsAlerts.createServiceError();
            }
          }
          this.$log.info('Closed Dialog');
        }
      )
  }

  declineServices() {
    const selectedServicesIdList = this.getSelectedServiceIdList();
    this.loading = true;

    this.coordinationRequests.declineServices(selectedServicesIdList)
      .then((updatedServices) => {
        this.loading = false;
        this.coordinationsAlerts.declineServicesSuccess();
        this.updateService(updatedServices);
        this.getCoordination()
      })
      .catch((error) => {
        this.coordinationsAlerts.declineServicesError();
        this.$log.error('Failed to decline service/s', error);
      })
  }

  sendServicesTextMessage() {
    const selectedServicesIdList = this.getSelectedServiceIdList();
    this.loading = true;

    this.coordinationRequests.sendServicesTextMessage(selectedServicesIdList)
      .then((updatedServices) => {
        this.loading = false;

        if (selectedServicesIdList.length > 1) {
          this.coordinationsAlerts.sendSMSToManyServicesSuccess();
        } else {
          this.coordinationsAlerts.sendSMSToServicesSuccess();
        }

        this.updateService(updatedServices);
        this.getCoordination()
      })
      .catch((error) => {

        if (selectedServicesIdList.length > 1) {
          this.coordinationsAlerts.sendSMSToManyServicesError();
        } else {
          this.coordinationsAlerts.sendSMSToServicesError();
        }

        this.$log.error('Failed to send SMS to all pending/idle services, ' +
          'coordinationActionsMenu@sendAllServicesSMS \n' + error)
      })
  }

  changeStatus(status) {
    this.loading = true;
    this.coordinationRequests.getServices(this.coordination.id, status)
      .then((services) => {
        this.loading = false;
        this.selectedServiceIds = {};
        this.selectAllServicesMode = false;
        this.services = services;
      })
      .catch((error) => {
        this.loading = false;
        this.$log.error('Failed to change services status, ' +
          'coordinationDetailedView@changeStatus' + error)
      })
  }

  updateService(updatedServices) {

    if (!_.isArray(updatedServices)) {
      updatedServices = [updatedServices];
    }
    _.forEach(updatedServices, (updatedService) => {
      const serviceIndex = _.findIndex(this.services, (service: any) => {
        return _.isEqual(service.id, updatedService.id);
      });

      if (!_.isEqual(serviceIndex, -1)) {
        this.services[serviceIndex] = updatedService;
        this.selectedServiceIds[updatedService.id] = false;
      }
    });

    this.getCoordination();
  }

  onOpenServicesActionMenu(callBack) {

    const selectedServicesList = [];

    _.forEach(this.selectedServiceIds, (value, key) => {
      if (_.isEqual(value, true)) {
        selectedServicesList.push(_.find(this.services, (service) => {
          return service.id === key;
        }));
      }
    });

    if (_.isEmpty(selectedServicesList)) {
      callBack({sendSms: true, declineAll: true, createDeliveries: true});
      return;
    }

    const declineAndSendSmsTest = _.find(selectedServicesList, (service) => {
        return _.isEqual(service.coordinationStatus, 'ServiceCreated') || _.isEqual(service.coordinationStatus, 'DeclinedByAdmin') || _.isEqual(service.coordinationStatus, 'DeclinedByUser')
      }),
      initDisableMenu = {
        sendSms: !_.isUndefined(declineAndSendSmsTest),
        declineAll: !_.isUndefined(declineAndSendSmsTest),
        createDeliveries: !_.isUndefined(_.find(selectedServicesList, (service) => {
          return !_.isEqual(service.coordinationStatus, 'ValidatedByUser') && !_.isEqual(service.coordinationStatus, 'ValidatedByAdmin')
        }))
      };
    callBack(initDisableMenu);
  }

  onSelectAllServices(mode) {
    _.forEach(this.services, (service) => {
      this.selectedServiceIds[service.id] = mode;
    });
  }

  // ******************************
  //        Internal methods
  // ******************************

  getCoordination() {
    this.$coordinations(this.coordination.id).$get()
      .then((coordination) => {
        this.coordination = coordination;
        this.loading = false;
      })
      .catch((error) => {
        this.$log.error('Failed to get services from server, ' +
          'coordinationDetailedView@getCoordination \n' + error);
      });
  }

  getServices() {
    this.coordinationRequests.getServices(this.coordination.id, status)
      .then((services) => {
        this.services = services;
        this.loading = false;
      })
      .catch((error) => {
          this.loading = false;
          this.$log.error('Failed to get service\'s services' +
            'coordinationsConfig@getServices \n' + error);
        }
      );
  }

  getSelectedServiceIdList() {
    const selectedServiceIdList = [];

    _.forEach(this.selectedServiceIds, (value, key) => {
      if (_.isEqual(value, true)) {
        selectedServiceIdList.push(key);
      }
    });

    return selectedServiceIdList;
  }
}

angular
  .module('bringoz.admin.coordinations')
  .component('coordinationDetailedView', {
    bindings: {
      coordination: '<',
      services: '<'
    },
    template: require('./coordination-detailed-view.tmpl.html').default,
    controller: coordinationDetailViewCtrl
  });
